import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../../../services/auth.service';

@Component({
  selector: 'app-ga-setup',
  templateUrl: './ga-setup.component.html',
  styleUrl: './ga-setup.component.scss',
})
export class GaSetupComponent implements OnInit {
  qrCode!: string;
  userId!: number;

  constructor(
    private auth: AuthService,
    private router: Router,
  ) {
    this.userId = Number(localStorage.getItem('otp_user_id'));
  }

  ngOnInit() {
    this.auth.generateGaQr(this.userId).subscribe((res: any) => {
      this.qrCode = res.qrCode;
    });
  }

  proceed() {
    this.router.navigate(['/ga-verify']);
  }
}
